import { CAMPAIGN_CATEGORIES, INFLUENCER_SIGNUP_CATEGORIES } from './marketplaceCategories';

export const MARKETPLACE_PLATFORM_OPTIONS = ['TikTok', 'Instagram', 'Whatnot'];

export const CAMPAIGN_MARKETPLACE_CATEGORY_OPTIONS = CAMPAIGN_CATEGORIES;

export const INFLUENCER_MARKETPLACE_CATEGORY_OPTIONS = INFLUENCER_SIGNUP_CATEGORIES;

export const CONTENT_FORMAT_FILTER_OPTIONS = [
  { value: 'Live', label: 'Live' },
  { value: 'Short-form', label: 'Short-form' },
];

/**
 * Influencer marketplace rating slider steps (min average threshold).
 * Values match API `minRating` and card display precision (one decimal).
 */
export const INFLUENCER_RATING_FILTER_OPTIONS = Object.freeze([
  { value: '3', label: '3+' },
  { value: '3.5', label: '3.5+' },
  { value: '4', label: '4+' },
  { value: '4.5', label: '4.5+' },
  { value: '5', label: '5' },
]);

/**
 * Influencer marketplace TikTok follower steps.
 * Values match API `minFollowers` (`under_1000` = fewer than 1,000).
 */
export const INFLUENCER_FOLLOWER_UNDER_1K_VALUE = 'under_1000';

export const INFLUENCER_FOLLOWER_FILTER_OPTIONS = Object.freeze([
  { value: INFLUENCER_FOLLOWER_UNDER_1K_VALUE, label: 'Under 1K' },
  { value: '1000', label: '1K+' },
  { value: '5000', label: '5K+' },
  { value: '10000', label: '10K+' },
  { value: '25000', label: '25K+' },
  { value: '50000', label: '50K+' },
  { value: '100000', label: '100K+' },
]);
